// ABOUTME: Route handler for Insights pages
// ABOUTME: Sets page title and renders child routes via Outlet

import { Outlet } from 'react-router-dom'

import { usePageTitle } from '~publish/hooks/usePageTitle'

import type { JSX } from 'react'

export const InsightsRouteHandler = (): JSX.Element => {
  usePageTitle('Insights')

  return <Outlet />
}
